<template>
  <div id="PageNetZero">
    <SectionHeroNetZero />
    <SectionTrust class="SectionTrust__net-zero" />
    <SectionLackTransitionPlans />
    <SectionNetZeroPartner />
    <SectionAchievedTarget />
    <SectionYourRoadmap />
    <SectionTrackRecord />
    <SectionNetZeroPricing />
    <SectionNetZeroFAQs />
  </div>
</template>

<script setup lang="ts">
import SectionTrust from '@/views/components/sections/SectionTrust.vue'
import SectionHeroNetZero from './sections/SectionHeroNetZero.vue'
import SectionLackTransitionPlans from './sections/SectionLackTransitionPlans.vue'
import SectionNetZeroPartner from './sections/SectionNetZeroPartner.vue'
import SectionAchievedTarget from './sections/SectionAchievedTarget.vue'
import SectionYourRoadmap from './sections/SectionYourRoadmap.vue'
import SectionNetZeroPricing from './sections/SectionNetZeroPricing.vue'
import SectionNetZeroFAQs from './sections/SectionNetZeroFAQs.vue'
import SectionTrackRecord from '@/views/components/sections/SectionTrackRecord.vue'
import {
  useSeo,
  getBreadcrumbStructuredData,
  getFAQStructuredData,
} from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// FAQ Data for structured data
const faqData = [
  {
    question: 'What is a Net Zero strategy?',
    answer:
      'A Net Zero strategy is a comprehensive plan to reduce greenhouse gas emissions to as close to zero as possible, with any remaining emissions balanced by carbon removal. It includes science-based targets, decarbonization initiatives, and a clear timeline to achieve carbon neutrality.',
  },
  {
    question: 'How long does it take to achieve Net Zero?',
    answer:
      "Most companies set Net Zero targets for 2040-2050, giving 20-30 years to achieve deep decarbonization. However, near-term milestones (5-10 years) are critical to ensure you're on track. Sustainalyse helps you create a realistic roadmap with measurable interim targets.",
  },
  {
    question: "What's the difference between carbon neutral and Net Zero?",
    answer:
      'Carbon neutral allows offsetting current emissions without reduction requirements. Net Zero requires reducing emissions by at least 90% before offsetting residual emissions. Net Zero is more rigorous and aligned with climate science and SBTi standards.',
  },
  {
    question: 'Do I need to reduce Scope 3 emissions for Net Zero?',
    answer:
      'Yes, Net Zero requires at least 90% reduction across all three scopes including Scope 3. Since Scope 3 typically represents 60-90% of total emissions for most companies, developing a Scope 3 reduction strategy is essential for credible Net Zero commitments.',
  },
  {
    question: 'How does Sustainalyse help with Net Zero planning?',
    answer:
      'We provide end-to-end Net Zero strategy development including baseline measurement, science-based target setting, decarbonization roadmap creation, initiative modeling, and progress tracking. Our platform integrates with SBTi requirements and TCFD reporting frameworks.',
  },
]

// SEO Configuration with FAQ schema
useSeo(getSeoConfig('netZero'), [
  getBreadcrumbStructuredData([
    { name: 'Home', url: 'https://sustainalyse.com/' },
    { name: 'Net Zero Strategy', url: 'https://sustainalyse.com/net-zero' },
  ]),
  getFAQStructuredData(faqData),
])
</script>

<style lang="scss" scoped>
#PageNetZero {
  min-height: 100vh;

  .SectionTrust__net-zero {
    background: linear-gradient(
      180deg,
      $color-ui-gray-cool-50 0%,
      $color-white 100%
    );
  }
}
</style>
